export default __webpack_public_path__ + "static/linea3-preview-1-mb-arg-d944eac2b183ca9d580af82265184c56.png";